import ApiService from '@/core/api/api.service';

import { functionsWithNotifications } from '@/core/notifications';
import invitationMessages from './invitation.messages';

const functions = {
  getCode,
};

export default {
  ...functionsWithNotifications(functions, invitationMessages),
};

const invitationApi = new ApiService();

async function getCode(invitationCode) {
  const cleanedUpCode = (invitationCode || '').replace(/[\W_-]/g, '').toLowerCase();
  const response = await invitationApi.get(`vendors/invitations/${cleanedUpCode}`);
  return response.data.data.attributes;
}
